import { VoiceBoard } from './VoiceBoard';

/** 현장 › 근로자 의견 청취 — 근로자가 현장 QR 로 낸 의견(V576 · DOC-136). */
export function SiteVoicePage({ siteId }: { siteId: string }) {
  return <VoiceBoard siteId={siteId} kind="OPINION" title="근로자 의견 청취" />;
}
